import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { LAYOUT_HEADER, LAYOUT_SIDEBAR } from 'config/constants/ui'
import { useInitiativeList, useOrganizationWithOptions } from 'src/graphql/hooks'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import ListMenuButton from '~/components/ListMenuButton'

const NavVertical = ({
   buttonActiveBackgroundColor,
   buttonActiveTextColor,
   buttonLineColor,
   buttonTextColor,
   onAppButtonClick,
   onNotebookButtonClick
}) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const isHeaderGL = theme.tmpGlobalLayout === LAYOUT_HEADER
   const isSidebarGL = theme.tmpGlobalLayout === LAYOUT_SIDEBAR

   const { initiativeList: notebookList } = useInitiativeList({ tag: 'root' })
   const { organization, loading } = useOrganizationWithOptions({
      withGlobalNavLinksTargetMetadata: true
   })

   if (loading) {
      return null
   }

   const isBleedingEdge = organization.gatherAppVersion === 6
   const buttonProps = {
      activeBackgroundColor: buttonActiveBackgroundColor ||
         theme.tmpMainMenuButtonActiveBackgroundColor,
      activeTextColor: buttonActiveTextColor || theme.tmpMainMenuButtonActiveTextColor,
      borderRadius: theme.tmpBorderRadius,
      borderStyle: `1px solid ${buttonLineColor || theme.tmpMainMenuLineColor}`,
      textColor: buttonTextColor || theme.tmpMainMenuButtonTextColor,
      height: isBleedingEdge ? theme.tmpSecondaryButtonHeight : theme.tmpPrimaryButtonHeight,
      showPlaceholderIcon: !isHeaderGL,
      textFontWeight: theme.tmpPrimaryButtonTextFontWeight,
      textSize: theme.tmpPrimaryButtonTextSize,
      textTransform: theme.tmpPrimaryButtonTextTransform
   }

   const { globalNavLinks } = organization
   // For legacy versions, do not include any app-related globalNavLinks
   let mainMenuLinks = globalNavLinks.filter(link => !link.app)

   if (isHeaderGL && organization.slug !== 'gns3') {
      const exploreLink = { id: 'explore', name: 'Explore', url: '/explore' }
      mainMenuLinks = [exploreLink, ...mainMenuLinks]
   }

   if (!isHeaderGL && organization.slug !== 'gns3' && !isBleedingEdge) {
      const initiativeTypeLinks = organization.initiativeTypes
         .filter(t => t.enabled)
         .map(type => ({
            id: type.id,
            name: type.namePlural,
            url: `/explore/${type.slug}`
         }))

      mainMenuLinks = [
         { id: 'latest', exact: true, name: 'Latest', url: '/' },
         ...initiativeTypeLinks,
         ...mainMenuLinks
      ]
   }

   return (
      <>
         <View onClick={onAppButtonClick}>
            {mainMenuLinks.map(link => (
               <ListMenuButton
                  key={link.id}
                  linkExact={link.exact}
                  linkIsExternal={link.__typename === 'NavExternalLinkElement'}
                  linkTo={link.url}
                  name={link.name}
                  {...buttonProps}
               />
            ))}
         </View>
         {isSidebarGL && notebookList.items.map(notebook => (
            <View key={notebook.id} onClick={() => onNotebookButtonClick(notebook.id)}>
               <ListMenuButton
                  key={notebook.id}
                  linkTo={`/notebook/${notebook.slug}`}
                  name={notebook.name}
                  showBadge={notebook.thread.hasUnreadEntries}
                  {...buttonProps}
               />
            </View>
         ))}
      </>
   )
}

NavVertical.propTypes = {
   buttonActiveBackgroundColor: PropTypes.string,
   buttonActiveTextColor: PropTypes.string,
   buttonLineColor: PropTypes.string,
   buttonTextColor: PropTypes.string,
   onAppButtonClick: PropTypes.func,
   onNotebookButtonClick: PropTypes.func
}

NavVertical.defaultProps = {
   buttonActiveBackgroundColor: undefined,
   buttonActiveTextColor: undefined,
   buttonLineColor: undefined,
   buttonTextColor: undefined,
   onAppButtonClick: undefined,
   onNotebookButtonClick: undefined
}

export default NavVertical
